module.exports = __webpack_public_path__ + "static/olayinka-3d1cc2d3c50f16a5fd8215b1c3f60bec.jpg";